import { defineStore } from "pinia"

import storage from "~/services/storage"

type NoticeState = Record<string, unknown>

export const useNoticesStore = defineStore("noticesStore", {
  state: () => ({
    notices: storage.getNotices() as Record<string, NoticeState>,
    sessionSkipped: [] as string[],
  }),

  actions: {
    dismissPermanently(id: string) {
      storage.setNoticeState(id, { dismissedAt: new Date().toISOString() })
      this.notices = storage.getNotices()
    },

    skipForSession(id: string) {
      if (!this.sessionSkipped.includes(id)) {
        this.sessionSkipped.push(id)
      }
    },
  },
})
